export default "__VITE_ASSET__DzC$BeId__"